module.exports = __webpack_public_path__ + "static/media/ss.8d10b401.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ss.svg
// module id = 2214
// module chunks = 0